import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { EventModel } from 'src_common/common/websocket2/models/EventModel';
import { SelectionModel } from 'src_common/common/websocket2/models/SelectionModel/SelectionModel';
import { Trap } from 'src/domains/sportsbook/webview/components/trap/Trap';
import {
    TrapChallengeContainer,
    TrapHeaderList,
    TrapNumberSilk,
    CompetitionRow,
    CompetitionRowName,
    CompetitionRowTrapList,
    CompetitionRowsWrapper,
} from 'src/domains/sportsbook/webview/components/containers/competitionsTrapChallenge/CompetitionsTrapChallengeGroup.style';
import { sortSelectionsByCriteria } from 'src_common/utils/sport/sort';
import { GreyhoundRacingRow } from 'src/domains/sportsbook/webview/components/raceSummary/raceSummaryRow/GreyhoundRacing/GreyhoundRacingRow';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';

interface CompetitionsTrapChallengeRowPropsType {
    event: EventModel;
}

const CompetitionsTrapChallengeRow = observer(
    'CompetitionsTrapChallenge',
    ({ event }: CompetitionsTrapChallengeRowPropsType): React.ReactElement | null => {
        const firstMarket = event.markets[0];
        const common = useCommon();
        const configState = ConfigComponents.get(common).config;
        if (firstMarket === undefined) {
            return null;
        }

        const competitionModel = event.competition2.getModel();
        const order = 'by-selection-name';
        const itemsForView = sortSelectionsByCriteria(firstMarket.selections, order);

        const selectionWithPriceHistory = (selection: SelectionModel): boolean => selection.priceHistory.length > 0;
        const hidePriceHistoryColumn = itemsForView.find(selectionWithPriceHistory) === undefined;

        return (
            <CompetitionRow variant={configState.componentVariants.sportsbookVariant}>
                <CompetitionRowName variant={configState.componentVariants.sportsbookVariant}>
                    {competitionModel === null ? null : competitionModel.name}
                </CompetitionRowName>

                <CompetitionRowTrapList variant={configState.componentVariants.sportsbookVariant}>
                    {itemsForView.map((selection: SelectionModel) => (
                        <GreyhoundRacingRow
                            key={selection.id}
                            selectionId={selection.id2}
                            type={undefined}
                            isPriceHistoryHidden={hidePriceHistoryColumn}
                        />
                    ))}
                </CompetitionRowTrapList>
            </CompetitionRow>
        );
    }
);

interface PropType {
    events: Array<EventModel>;
}

export const CompetitionsTrapChallengeGroup = observer('CompetitionsTrapChallengeGroup', (props: PropType) => {
    const { events } = props;
    const common = useCommon();
    const configState = ConfigComponents.get(common).config;

    const { sportsbookVariant } = configState.componentVariants;
    const TRAP_ARRAY = [1, 2, 3, 4, 5, 6];

    return (
        <TrapChallengeContainer variant={sportsbookVariant}>
            <TrapHeaderList variant={sportsbookVariant}>
                {TRAP_ARRAY.map((item) => (
                    <TrapNumberSilk
                        key={item}
                        variant={sportsbookVariant}
                    >
                        <Trap
                            trapNumber={item}
                            selectionId={null}
                        />
                    </TrapNumberSilk>
                ))}
            </TrapHeaderList>

            <CompetitionRowsWrapper variant={sportsbookVariant}>
                {events.map((event: EventModel) => (
                    <CompetitionsTrapChallengeRow
                        event={event}
                        key={event.id}
                    />
                ))}
            </CompetitionRowsWrapper>
        </TrapChallengeContainer>
    );
});
